<div class="wrapper">
  <ng-container *ngFor="let filter of filters">
    <div class="option" (click)="onSelectFilter(filter)">
      <span [class.selected]="filter.selected">{{ filter.label }}</span>
      <img [src]="filter.img" alt="" />
    </div>
  </ng-container>
</div>
